export default "__VITE_ASSET__D7ayL683__"